import { DATE_FORMAT_SHORT } from 'common/data/constants';
import { format } from 'date-fns';
import i18n from 'i18n';
import en from 'date-fns/locale/en-US';
import de from 'date-fns/locale/de';

export const formatDate = (value, formatDate = DATE_FORMAT_SHORT) => {
  if (!value) return '';

  const date = new Date(value);
  if (isNaN(date.getTime())) return '';

  return format(date, formatDate, {
    locale: i18n.language === 'de' ? de : en,
  });
};
